import { Box } from '@mui/system';
import React from 'react';

const CenteredFlexContainer = ({ children, sx, ...otherProps }) => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        justifyContent: 'center',
        ...sx  // Merge with any additional sx props
      }}
      {...otherProps}  // Spread all other props to the Box component
    >
      {children}
    </Box>
  );
};

export default CenteredFlexContainer;